import axios from '@/axios'

const customers = {
  async getRebates(params) {
    return await axios.post('/uc/commissionManage/tradeInfoDetails', params, { des: '直客wap获取佣金详情', sTime: new Date().getTime() })
  },
  async getWalletInfo(params) {
    return await axios.post('/uc/commissionManage/electronicWallet', params, { des: '直客wap获取钱包信息', sTime: new Date().getTime() })
  },
  async getBankList(params = {}) {
    return await axios.post('/uc/commissionManage/choiceBankList', params, { des: '直客wap获取银行列表', sTime: new Date().getTime() })
  },
  async getBankInfo(params) {
    return await axios.post('/uc/commissionManage/choiceBank', params, { des: '直客wap获取银行信息', sTime: new Date().getTime() })
  },
  async getRateInfo(params = {}) {
    return await axios.post('/uc/commissionManage/applyGold', params, { des: '直客wap佣金提取至银行卡-获取提现界面信息', sTime: new Date().getTime() })
  },
  async extractMoney(params) {
    return await axios.post('/uc/commissionManage/extractCommission', params, { des: '直客wap提取佣金', sTime: new Date().getTime() })
  },
  // 获取机构客户
  async getInstitutionInfo(params) {
    return await axios.post('/uc/wap/agent/agentCustomer', params, { des: '直客wap获取机构客户', sTime: new Date().getTime() })
  },
  // 获取普通客户
  async getOrdinaryInfo(params) {
    return await axios.post('/uc/wap/agent/ordinary', params, { des: '直客wap获取普通客户', sTime: new Date().getTime() })
  },
  // 修改返佣
  async modifyRebate(params) {
    return await axios.post('/uc/agent/agentUpdate', params, { des: '直客wap修改返佣', sTime: new Date().getTime() })
  }
}

export default customers


// WEBPACK FOOTER //
// ./src/api/customers.js